export default function NavBar({ current, onNav, logoUrl, onAdmin, isAdmin }) {
  const links = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'empresa', label: 'Empresa' },
    { id: 'organigrama', label: 'Organigrama' },
    { id: 'departamentos', label: 'Departamentos' },
    { id: 'directorio', label: 'Directorio' },
  ];
  return (
    <nav className="nav">
      <div className="nav-logo">
        <img src={logoUrl} alt="Brokalia" onError={e => e.target.style.display='none'} />
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:4 }}>
        <div className="nav-links">
          {links.map(l => (
            <button key={l.id} className={`nav-btn${current===l.id?' active':''}`} onClick={() => onNav(l.id)}>
              {l.label}
            </button>
          ))}
        </div>
        <button className="nav-admin-btn" onClick={onAdmin}>
          {isAdmin ? '⚙ Admin' : '🔐 Admin'}
        </button>
      </div>
    </nav>
  );
}
